import { render, staticRenderFns } from "./AddClass.vue?vue&type=template&id=53fa49e0&"
import script from "./AddClass.vue?vue&type=script&lang=ts&"
export * from "./AddClass.vue?vue&type=script&lang=ts&"
import style0 from "./AddClass.vue?vue&type=style&index=0&id=53fa49e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports